module.exports = __webpack_public_path__ + "static/img/draw_area.9a1a880.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/1314/draw_area.png
// module id = 476
// module chunks = 1